import styled from 'styled-components';
import {
  DescriptionHyperLink as DescriptionHyperLinkCommon,
  DescriptionValue,
  TruncatedTitle,
} from '../../ItemCommons/CommonItem.styles';

const Name = styled(TruncatedTitle)`
  margin-bottom: 8px;
  -webkit-line-clamp: 1;
`;

const DescriptionLabel = styled(TruncatedTitle)`
  -webkit-line-clamp: 1;
`;

const DescriptionBody = styled(DescriptionValue)<{
  showReasonForReturn?: boolean;
}>`
  margin-top: 8px;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: ${({ showReasonForReturn }) =>
    showReasonForReturn ? '1' : '5'};
  -webkit-box-orient: vertical;
  display: -webkit-box;
`;

const ReasonForReturnBody = styled(DescriptionBody)`
  -webkit-line-clamp: 2;
`;

const DescriptionHyperLink = styled(DescriptionHyperLinkCommon)`
  bottom: 16px;
  position: absolute;
`;

export {
  Name,
  DescriptionBody,
  DescriptionHyperLink,
  DescriptionLabel,
  ReasonForReturnBody,
};
